import React, { useMemo } from 'react'
import { Card, Spinner } from '@shopify/polaris'
import { Bar } from 'react-chartjs-2'
import _ from 'lodash'

const chartSeriesColors = ["#9c6ade", "#59c7c5", "#0090f0", "#5C6AC4"]

const TransactionsByCountryOmpSection = ({ transByCountry, fetchingTransByCountry, t }) => {
	const rows = useMemo(() => {
		return transByCountry ? [...transByCountry.items].reverse() : []
	}, [transByCountry])

	const chartData = useMemo(() => {
		if (_.isEmpty(rows)) return null

		return {
			labels: rows.map((item) => item.country),
			datasets: [
				{
					data: rows.map((item) => item.amount),
					backgroundColor: chartSeriesColors[0],
				},
			],
		}
	}, [rows])

	const chartOptions = useMemo(() => ({
		indexAxis: "y",
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: false,
			},
		},
		scales: {
			x: {
				beginAtZero: true,
				position: "bottom",
				ticks: {
					callback: (value) => `${value}%`,
				},
			},
			y: {
				reverse: true,
			},
		},
	}), [])

	return (
		<Card
			title={t("home.transactionsByCountry")}
			sectioned={fetchingTransByCountry}
		>
			{fetchingTransByCountry ? (
				<Spinner />
			) : (
				<>
					{!_.isEmpty(rows) ? (
						<div
							style={{
								width: "100%",
								height: `${100 + rows.length * 30}px`,
								padding: "1rem",
							}}
						>
							<Bar data={chartData} options={chartOptions} />
						</div>
					) : (
						<p style={{ padding: "2rem" }}>{t("home.noData")}</p>
					)}
				</>
			)}
		</Card>
	)
}

export default TransactionsByCountryOmpSection

